import React from 'react';

export function EmptyState() {
	return (
		<div>
			<p className="text-center text-gray-500 text-sm">Aucun choix renseigné</p>
		</div>
	);
}
